import { Component } from '@angular/core';

@Component({
    selector: 'report-viewer-with-navbar',
    templateUrl: './with-navbar.component.html',
    styleUrls: ['./with-navbar.component.less'],
    standalone: false
})
export class WithNavbarComponent {
  constructor() {}
}
